/**
 * Triggers a browser download of an already-fetched Blob via a transient <a download> element.
 * The filename is entirely client-side because Content-Disposition is not readable across CORS
 * (nelmio_cors only exposes the 'Link' header, see accidentEvaluationApi.ts).
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
